import type { Invoice } from '../types';

export function invoiceOrderLabel(invoice: Invoice): string {
  if (invoice.platform_order_name) {
    return invoice.platform_order_name;
  }

  if (invoice.original_invoice?.platform_order_name) {
    return invoice.original_invoice.platform_order_name;
  }

  return invoice.platform_order_id ? `#${invoice.platform_order_id}` : '—';
}
